import client from './api-client';

export const getConfiguracionForm29 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form29: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const obtenerDatosSolicitud = async(query) => {
    try {
        
        const response = await client.get(`gestion-implicado/sol-descuento?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosSolicitudDescuento: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboAprobacion = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboAprobacion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const postProcesar = async(file) => {
    try {
        
        const response = await client.post('gestion-implicado/sol-descuento', file);
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaProcesar: response.data};
        } else {
            return {respuestaProcesar: response.data};
        }
        
    } catch(error){
        throw error;
    }
}
